import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';
import animator from '../../helpers/animator';
import warningIcon from '../../assets/images/warning.svg';
import FileUploader from '../FileUploader';
import '../PopupView/PopupView.scss';
import './QueryDialog.scss';

export class QueryDialog extends BaseComponent {

  constructor(props) {
    super(props);
    this.handleWidth = 100;
    this.state = { height: '0px', width: '0px', movedByMouse: false, mouseX: 0, mouseY: 0, currentPage: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.queryDialogId = this.props.queryDialogId;
    this.animator = new animator();
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ viewWidth: window.innerWidth, viewHeight: window.innerHeight });
  }

  handleCancelClick(e) {
    if (e) {
      e.stopPropagation();
    }
    const _this = this;
    const ani = _this.animator.createPropertyAnimation('query-dialog-view-' + _this.props.queryDialog.popupId, 500, { opacity: { startVal: 1, endVal: 0 } });
    this.animator.addAnimation(ani);
    this.animator.processAnimationQueue(() => {
      let { handleOwnerCancel } = _this.props.queryDialog;
      if (handleOwnerCancel != undefined) {
        handleOwnerCancel(this.props.queryDialog.queryDialogId);
      }
    });
  }

  handleOKClick(e) {
    if (e) {
      e.stopPropagation();
    }
    const _this = this;
    const ani = _this.animator.createPropertyAnimation('query-dialog-view-' + _this.props.queryDialog.popupId, 500, { opacity: { startVal: 1, endVal: 0 } });
    this.animator.addAnimation(ani);
    this.animator.processAnimationQueue(() => {
      let { handleOwnerOk } = _this.props.queryDialog;
      if (handleOwnerOk != undefined) {
        handleOwnerOk(this.props.queryDialog.id);
      }
    });
  }

  handleMouseMove(e){
    e = this.fixupMouse(e);
    if (this.mouseDown){
      let deltaX = e.clientX - this.startX;
      let deltaY = e.clientY - this.startY;
      this.lastLeft = this.left + deltaX;
      this.lastTop = this.top + deltaY;
      this.setState({ movedByMouse: true, mouseX: this.lastLeft,
        mouseY: this.lastTop });
    }
  }

  handleMouseDown(e) {
    e = this.fixupMouse(e);
    let inCaption = false;
    if (e.target.className.indexOf('caption') >= 0) {
      inCaption = true;
    }
    else {
      let parent = e.target.parentElement;
      while (parent) {
        if (parent.className.indexOf('caption') >= 0) {
          inCaption = true;
          break;
        }
        parent = parent.parentElement;
      }
    }
    if (inCaption || e.target.className == 'popup-contents') {
      this.mouseDown = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.setState({ movedByMouse: true, mouseX: this.left, mouseY: this.top });
    }
  }

  handleMouseUp(e){
    e = this.fixupMouse(e);
    this.mouseDown = false;
    let newState = {};
    if (this.lastLeft < 0){
      this.lastLeft = newState.mouseX = 0;
    }
    if (this.lastTop < 0){
      this.lastTop = newState.mouseY = 0;
    }
    if(this.lastLeft + this.width > window.innerWidth){
      this.lastLeft = newState.mouseX = window.innerWidth - this.width;
    }
    if (this.lastTop + this.height > window.innerHeight){
      this.lastTop = newState.mouseY = window.innerHeight - this.height;
    }
    this.left = this.lastLeft;
    this.top = this.lastTop;
    this.setState(newState);
  }

  handleThrowAwayClick(e){
    e.stopPropagation();
  }

  handleKeyDown(e) {
    if (e.keyCode == 27) {
      this.handleCancelClick();
    }
    else if (e.keyCode == 13) {
      this.handleOKClick();
    }
  }

  animateMe() {
    if (!this.animating) {
      this.animating = true;
      const _this = this;
      setTimeout(() => {
        const ani = _this.animator.createPropertyAnimation('query-dialog-view-' + _this.props.queryDialog.popupId, 500, { opacity: { startVal: 0, endVal: 1 } });
        _this.animator.addAnimation(ani);
        _this.animator.processAnimationQueue(() => {
          _this.animating = false;
          _this.animated = true;
        });
      }, 10);
    }
  }

  render() {
    let { left, top, width, height, pages, oneButton, cancelButtonText, okButtonText, okButtonColor, type, captionText, useInput } =
      this.props.queryDialog;

    if (pages == null) {
      pages = [];
      pages.push(<div>THERE SHOULD BE SOMETHING TO DISPLAY HERE</div>);
    }
    
    const style = { };
    if (width) {
      style.width =  width + 'px';
    }
    if (height) {
      style.height = height + 'px';
    }

    if (this.state.movedByMouse) {
      left = this.state.mouseX;
      top = this.state.mouseY;
    }

    else {
      if (left == undefined) {
        left = window.innerWidth / 2 - (width != undefined ?
          width / 2 : window.innerWidth / 4);
      }
      this.left = left;

      if (top == undefined) {
        top = Math.max(20, window.innerHeight / 2 - (this.height != undefined ?
          this.height / 2 : window.innerHeight / 4));
      }
      this.top = top;
    }
    style.left = left + 'px';
    style.top = top + 'px';

    let classNames = 'query-popup-view';

    let buttonText = okButtonText ? okButtonText.toUpperCase() : 'OK';
    let clickHandler = this.handleOKClick;
    let okButtonClass = 'query-dialog-next-button query-dialog-button';
    if (okButtonColor) {
      okButtonClass+= ' query-dialog-next-button--'+okButtonColor;
    }
    let okButton = <div className={okButtonClass} onClick={clickHandler}>{buttonText}</div>;

    if(useInput){
      okButton = (
        <FileUploader 
          text={buttonText}
          handleFileSelect={this.props.queryDialog.handleOwnerOk}
          className={'query-dialog-next-button query-dialog-button'}
        />
      );
    }

    let cancelButton = null;
    if (oneButton) {
      cancelButton = null;
    }
    else {
      cancelButton = <div className="query-dialog-cancel-button query-dialog-button" onClick={this.props.queryDialog.handleCancel ? this.props.handleCancel : this.handleCancelClick}>{cancelButtonText ? cancelButtonText.toUpperCase() : 'CANCEL'}</div>;
    }

    let mouseMove = null;
    let mouseDown = null;
    let mouseUp = null;
    mouseMove = this.handleMouseMove;
    mouseDown = this.handleMouseDown;
    mouseUp = this.handleMouseUp;

    const outerClasses = 'outer-query-popup tinted-background ' + type;
    let outerStyle = { height: Math.max(window.innerHeight, this.top + this.height + 20) + 'px' };
    if (!this.animated) {
      outerStyle.opacity = 0;
    }
    else {
      outerStyle.opacity = 1;
    }
    if (!this.animated || this.props.queryDialog.fromCrop) {
      this.props.queryDialog.fromCrop = false;
      this.animateMe();
    }

    let captionIcon = null;
    if (type == 'warning') {
      captionIcon = <img src={warningIcon} className="caption-icon" alt='warning icon'/>;
    }

    const innerPopup =
      <div className={classNames} style={style} onClick={this.handleThrowAwayClick}
        onMouseMove={mouseMove}
        onMouseUp={mouseUp}
        onMouseDown={mouseDown}
        onMouseLeave={mouseUp}
      >
        <div className={'query-popup-contents ' + (this.props.queryDialog.short ? 'short' : '')} >
          <div className="query-popup-caption-bar">
            <div className="caption-content caption">
              {captionIcon}  
              <div className="caption-text">
                {captionText}
              </div>  
            </div>  
          </div>  
          {this.props.queryDialog.content}
        </div>
        <div className="query-dialog-footer">
          {cancelButton}
          {okButton}
        </div>
      </div>;

    return (
      // Replace with the appropriate HTML
      <div id={'query-dialog-view-' + this.props.queryDialog.popupId} className={outerClasses} style={outerStyle} >
        {innerPopup}
      </div>
    );
  }
}

export default (QueryDialog);



// WEBPACK FOOTER //
// ./src/components/QueryDialog/index.js